import { render } from "./chat-npc.vue?vue&type=template&id=5bae172c&scoped=true"
import script from "./chat-npc.vue?vue&type=script&lang=js"
export * from "./chat-npc.vue?vue&type=script&lang=js"

import "./chat-npc.vue?vue&type=style&index=0&id=5bae172c&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bae172c"]])

export default __exports__